import React, {useEffect, useState} from "react";
import SVG from "react-inlinesvg";
import SimpleTable from "my-simple-react-table";
import TableSkeleton from "../../../../../../../util/TableSkeleton";
import { toAbsoluteUrl } from "../../../../../../../../_metronic/_helpers";
import * as handlers from "../../../../../_redux/selected-user/selectedUserHandlers";
import { useSelector, shallowEqual, useDispatch } from "react-redux"
import {formatDate, permissionCssClass} from "../../../../../../../util/Helpers";
import ViewSavedCardModal from "./modal/ViewSavedCardModal";
import DeleteSavedCardModal from "./modal/DeleteSavedCardModal";
import { Permissions, PermissionType } from "../../../../../../../util/Permissions";

const SavedCards = props => {

    const adminUser = useSelector(state => state.auth.user);
    /* Get User Saved Cards from redux */
    const [savedCards, notification] = useSelector(({selectedUser}) => [selectedUser.data?.savedCards, selectedUser.notification], shallowEqual);
    /* Saved Card Modal State Management */
    const [savedCardModal, setSavedCardModal] = useState({showViewSavedCardModal: false, showDeleteSavedCardModal: false, details: null});

    // Redux dispatch
    const dispatch = useDispatch();

    /* Fetch User Saved Cards on success notification */
    useEffect(() => {
        if (notification?.message === "User Saved Card Deleted"){
            dispatch(handlers.fetchUserSavedCards(props.match.params.userId));
        }
    }, [dispatch, notification, props.match.params.userId]);

    /* Fetch User Saved Cards */
    useEffect(() => {
        dispatch(handlers.fetchUserSavedCards(props.match.params.userId));
    }, [dispatch, props.match.params.userId]);

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setSavedCardModal({...savedCardModal, [modal]: !savedCardModal[modal]})
    }

    const formatCard = row => {
        return <div className="d-flex align-items-center" style={{whiteSpace: "nowrap"}}>
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SVG
                            title=""
                            src={toAbsoluteUrl("/media/svg/icons/Shopping/Credit-card.svg")}
                        />
                    </span>
                    <div>
                        <span className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">
                            {row.cardType}
                            <span className="text-muted pl-2">
                                 ***{row.last4} - {row.countryCode}
                            </span>
                        </span>
                    </div>
                </div>
    }

    // Action Butons
    const actionButton = row => {

        return  <span style={{whiteSpace: "nowrap"}}>
                    <button
                        className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                        onClick={_ => viewSavedCardDetails(row.cardId)}
                        >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                            title="View payment"
                            src={toAbsoluteUrl("/media/svg/icons/General/Eye-2.svg")}
                            />
                        </span>
                    </button>

                    <button
                        className={`btn btn-icon btn-light btn-hover-danger btn-sm ${permissionCssClass(adminUser, Permissions.SAVED_CARDS, PermissionType.DELETE)}`}
                        onClick={_ => deleteSavedCard(row.cardId)}
                        >
                        <span className="svg-icon svg-icon-md svg-icon-danger">
                        <SVG 
                            title="Delete Saved Card"
                            src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} 
                        />
                        </span>
                    </button>
                </span>
    }

                

    // View Saved Card Details
    const viewSavedCardDetails = cardId => {
        const details = savedCards.filter(savedCard => cardId === savedCard.cardId)[0];
        setSavedCardModal({...savedCardModal, showViewSavedCardModal: true, details});
    }

    // Delete Saved Card
    const deleteSavedCard = cardId => {
        const details = savedCards.filter(savedCard => cardId === savedCard.cardId)[0];
        setSavedCardModal({...savedCardModal, showDeleteSavedCardModal: true, details});
    }

    return  <div className="card card-custom gutter-b">
                <div className="row">
                    <div className="col-12">
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="card-header border-0">
                                {/* <!--begin::Title--> */}
                                <div className="card-title pt-5 w-100">
                                    <h3 className="card-label">
                                        <span className="d-block text-dark h3 font-weight-bolder">Saved Cards</span>
                                        <span className="d-block text-muted mt-2 font-size-sm">User Card Payment Authorization</span>
                                    </h3>
                                </div>
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-0">
                                {
                                    savedCards ?
                                        <SimpleTable
                                            data={savedCards}
                                            columns={[
                                                        {title:"CARD", format: formatCard},
                                                        {title:"EXPIRE", key: "expire"},
                                                        {title:"GATEWAY", key: "gateway"},
                                                        {title: "DATE", format: row => formatDate(row.createdAt)},
                                                        {title: "", format: actionButton}
                                                    ]} 
                                        />
                                        :
                                        <TableSkeleton/>
                                }
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}
                    </div>
                </div>
                <ViewSavedCardModal {...savedCardModal} onHide={toggleModal("showViewSavedCardModal")} />
                <DeleteSavedCardModal {...savedCardModal} onHide={toggleModal("showDeleteSavedCardModal")} />
            </div>

}

export default SavedCards;